export default __webpack_public_path__ + "static/media/keysOfRhapsody.c0829c68.png";